import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { EuiDialogComponent } from '../eui-dialog.component';
import { EuiDialogConfig } from '../models/dialog.config.model';

@Injectable()
export class EuiDialogService {

    constructor(public dialog: MatDialog) {}

    public openDialog(config: EuiDialogConfig) {
        return this.dialog.open(EuiDialogComponent, {
            data: config,
            id: config.id,
            disableClose: config.disableClose,
            width: config.width,
            // height: config.height,
            panelClass: config.typeClass ? ['eui-dialog', 'eui-dialog--' + config.typeClass] : ['eui-dialog'],
        });
    }

    public closeDialog(dialog: MatDialogRef<any>) {
        dialog.close();
    }

    public closeAllDialog() {
        this.dialog.closeAll();
    }
}
